import { useEffect } from 'react'
import { useDispatch, useSelector } from 'react-redux'

import useTextContents from '../../hooks/useTextContents'
import MainLoader from '../../icons/MainLoader/MainLoader'
import { SessionStorage } from '../../common/cookie-storage'
import { STORAGEKEYS } from '../../common/keys'
import videoVerificationService from '../../service/VideoVerificationService'
import { sleep } from '../../common/helpers/helpers'
import analyticsService from '../../service/analytics.service'
import { SET_APP_HAS_ERROR } from '../../store/actions/application-actions'
import { selectUserEmailFromState } from '../../store/reducers/customSelectors'
import { AppState } from '../../store'

/**
 * Komponent obsługujący powrót użytkownika z wideo weryfikacji
*/
const VideoVerificationBackFromPartnerPage = () => {
   const DEFAULT_SLEEP_TIME = 2000

   const textContent = useTextContents()
   const dispatch = useDispatch()
   const sessionStorage = new SessionStorage()
   const email = useSelector(selectUserEmailFromState)
   const sessionId = useSelector((state: AppState) => state.videoVerificationState.sessionId) as string
   const ANALYTICS_EVENT_TYPES_NAMES = useSelector((state: AppState) => state.lenConfigState.analyticsEventTypesNames)
   const alphaId = sessionStorage.get(STORAGEKEYS.SET_ALPHA_ID) as string


   useEffect(()=> {
      (async () => {
         try {
            const isUserPassVerification = await videoVerificationService.checkIfUserPassVerification({ sessionId: sessionId })
            await sleep(DEFAULT_SLEEP_TIME) //Sztucznie "przytrzymujemy" użytownika na stronie przez chwilę

            if (isUserPassVerification) {
               await videoVerificationService.videoVerificationVerification({ email, sessionId })
            }
         }
         catch (e: any) {
				const ERROR_ANALYTICS_DATA = {
					id: analyticsService.DISPLAY_ERROR_PAGE_IDS.VIDEO_VERIFICATION_BACK_FROM_PARTNER_VERIFICATION_FAIL,
					reason: `Nieudany powrót z wideo weryfikacji - sprawdzenie statusu wideo weryfikacji zakończyło się niepowodzeniem (/videoVerification/manual/verification).`,
					details: {
						description: e.message,
						errorDataFromBackend: e?.data,
						additionalData: {
							description: 'Parametry, które zostały wysłane do backendu w celu sprawdzenia statusu wideo weryfikacji',
							email, sessionId, alphaId
						}
					},
				}
				
				dispatch({ type: SET_APP_HAS_ERROR }) //Ustawiamy globalny błąd aplikacji co spowoduje przejście na ekran z błędem
				await analyticsService.createSingleAnalyticEvent(ANALYTICS_EVENT_TYPES_NAMES?.FrontendErrorPageDisplayed, JSON.stringify(ERROR_ANALYTICS_DATA, undefined, 3))
         }
      })()
   }, [])
  
   // Domyślnie prezentowany ekran oczekiwania - nie robimy apphistory.push na ekran oczekiwania, bo to by nic nie zmieniło
   return <MainLoader headingText={textContent('loaders.default')} />
}

export default VideoVerificationBackFromPartnerPage